const TOKEN_KEY = 'maint_access_token'
const USER_KEY = 'maint_user'

export function getToken() { return localStorage.getItem(TOKEN_KEY) }
export function setToken(token) { localStorage.setItem(TOKEN_KEY, token) }
export function removeToken() { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(USER_KEY) }
export function getUser() { try { return JSON.parse(localStorage.getItem(USER_KEY)) } catch(e) { return null } }
export function setUser(user) { localStorage.setItem(USER_KEY, JSON.stringify(user)) }
